import { CircularProgress } from '@mui/material';

import { Wrapper } from './components/Wrapper';
import { LOADER_STYLES } from './constants';

import type { LoaderSize } from './types';
import type { FC } from 'react';

export const LOADER_TEST_ID = 'loader';

interface LoaderProps {
  size?: LoaderSize;
}

export const Loader: FC<LoaderProps> = ({ size = 'lg' }) => {
  const { gap, loaderSize } = LOADER_STYLES[size];

  return (
    <Wrapper data-testid={LOADER_TEST_ID} sx={{ gap }}>
      <CircularProgress size={loaderSize} />
    </Wrapper>
  );
};
